import { ContractLocation } from './interfaces'

export const getLocationString = (location: ContractLocation) => {
  if (!location.locationUnit) {
    return ''
  }
  let locationUnitTypeName = ''
  if (location.locationUnit.locationUnitType) {
    locationUnitTypeName = `${location.locationUnit.locationUnitType.name} `
  }

  return `${locationUnitTypeName}${location.locationUnit.name}, ${location.locationUnit.locationUsage.name}`
}

export const getLocationsString = (locations: ContractLocation[]) =>
  locations.map(location => getLocationString(location)).join('; ')

export const getLocationUnitOption = locationUnit => ({
  value: locationUnit.id,
  label: `${locationUnit.locationUnitType.name} ${locationUnit.name}`,
  groupBy: locationUnit.locationUnitType.name
})

export const flatten = ({ childList }) =>
  childList.flatMap(({ childList = [], ...rest }) => [rest, ...flatten({ childList })])
